import { render, staticRenderFns } from "./send-log.vue?vue&type=template&id=2639909f&scoped=true&"
import script from "./send-log.vue?vue&type=script&lang=js&"
export * from "./send-log.vue?vue&type=script&lang=js&"
import style0 from "./send-log.vue?vue&type=style&index=0&id=2639909f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639909f",
  null
  
)

export default component.exports